import client from './index';

interface UserInfo {
  oldPassword: string;
  newPassword: string;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async getPersonalInfo() {
    const response = await client.get('/v1/user/personal');
    return response.data;
  },

  async getPlayerInfo(token: string) {
    const response = await client.get('/v2/player/info', {headers: {'player-token': token}});
    return response.data;
  },

  async updatePlayerInfo(token: string, formValues: {[x: string]: any}) {
    const response = await client.patch(
      '/v2/player/info/update',
      {
        ...formValues,
      },
      {
        headers: {'player-token': token},
      }
    );
    return response.data;
  },

  async updateFirstLogin(token: string) {
    const response = await client.patch(
      `/v2/player/first-login/update`,
      {},
      {
        headers: {'player-token': token},
      }
    );
    return response.data;
  },

  async redeemDemoCoin(token: string) {
    const response = await client.post(
      '/v2/player/redeem-demo',
      {},
      {
        headers: {'player-token': token},
      }
    );
    return response.data;
  },

  async changePersonalInfo(data: UserInfo) {
    const response = await client.patch('/v1/user/personal', data);
    return response.data;
  },

  async register(accessToken: string, gatewayUserName: string) {
    const response = await client.post(
      '/v1/gateway/player/register',
      {
        gatewayUserName,
      },
      {
        headers: {
          Authorization: accessToken,
        },
      }
    );
    return response.data;
  },

  async loginCms(userId: string, password: string) {
    const response = await client.post('/v1/user/login', {
      userId,
      password,
    });
    return response.data;
  },

  async loginPlayer(accessToken: string, gatewayUserName: string) {
    const response = await client.post(
      '/v2/player/gateway/login',
      {
        gatewayUserName,
      },
      {
        headers: {
          Authorization: accessToken,
        },
      }
    );
    return response.data;
  },

  async logout() {
    const response = await client.delete('/v1/user/logout');
    return response.data;
  },
  async getUserPermissions() {
    const response = await client.get('/v1/user/permissions');
    return response.data;
  },

  async resetPassword(token: string, password: string) {
    const response = await client.patch('/v1/user/reset-password', {
      token,
      password,
    });
    return response.data;
  },
  async getTwoFAQrCode() {
    const response = await client.post('/v1/user/two-factor');
    return response.data;
  },

  async updateTwoFactor(token: string, enable: boolean) {
    const response = await client.patch('/v1/user/two-factor', {
      token,
      enable,
    });
    return response.data;
  },
  async socialLogin(token: string, type: string) {
    const response = await client.post('/v1/user/social/login', {
      token,
      type,
    });
    return response.data;
  },
};
